import { useCallback } from 'react';

import { S3_BUCKET_URL } from '@/constants';
import { webCampaign } from '@/modules/webCampaign';
import { preloadImage } from '@/utils/preloadImage';

export const useSummaryPreload = () => {
  const preloadSummaryImages = useCallback(
    (screenName: 'summary-intro' | 'summary-deep' | 'summary-final') => {
      const notes = webCampaign.getLayoutNotes();
      const isLucy = notes?.includes('lucy');
      const basePath = isLucy ? 'lucy' : 'jia';

      const imagePath = `${S3_BUCKET_URL}/layout-own-ai-dominate-v2/${basePath}/summary-screens/${screenName}-background.png`;
      preloadImage(imagePath);
    },
    [],
  );

  return { preloadSummaryImages };
};
